import React, {Component} from 'react';
import {Translation} from 'react-i18next';

import ResourceNoteForm from '../containers/ResourceNoteFormContainer';
import DocumentHead from '../../../elements/components/DocumentHead';
import Logger from '../../../../../lib/Logger';

class ResourceNoteEditScreen extends Component {

  scrollToTop = () => {
    Logger.log('debug', `ResourceNoteEditScreen.scrollToTop()`);
    if (typeof window !== 'undefined') {
      setTimeout(() => window.scrollTo(0, 0), 100);
    }
  }

  render() {
    return (
      <Translation>{(t) => 
        <div>
          <DocumentHead title={t('resource_note_route_edit')} />
          <ResourceNoteForm id={this.props.match.params.id} />
        </div>
      }</Translation>
    )
  }

  /* LIFECYCLE EVENTS */

  componentDidMount() {
    this.scrollToTop();
  }
}

export default ResourceNoteEditScreen;

Logger.log('silly', `ResourceNoteEditScreen loaded.`);
